import React from 'react';
import DashboardPageHeader from './DashboardPageHeader';
import VendorDashboardLayout from './VendorDashboardLayout';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export default function VendorDashboard() {
  return (
    <VendorDashboardLayout>
      <DashboardPageHeader
        title="Добре дошли"
        subtitle="Управлявайте каталога на GoToBed от едно спокойно и подредено място."
        icon={DashboardRoundedIcon}
      />

      <Box
        sx={{
          background: 'linear-gradient(120deg, #312e81 0%, #4f46e5 55%, #6366f1 100%)',
          borderRadius: 4,
          color: 'white',
          mb: 3,
          overflow: 'hidden',
          p: { xs: 3, md: 5 },
          position: 'relative'
        }}
      >
        <Box
          sx={{
            bgcolor: 'rgba(255,255,255,.08)',
            borderRadius: '50%',
            height: 260,
            position: 'absolute',
            right: -70,
            top: -100,
            width: 260
          }}
        />
        <Box
          component="img"
          src="/gotobed_logo.jpg"
          alt="GoToBed"
          sx={{
            borderRadius: 4,
            boxShadow: '0 18px 45px rgba(15, 23, 42, .3)',
            display: { xs: 'none', md: 'block' },
            height: 180,
            objectFit: 'cover',
            position: 'absolute',
            right: 48,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 180
          }}
        />
        <Box sx={{ maxWidth: { xs: '100%', md: 'calc(100% - 230px)' }, position: 'relative' }}>
          <Box
            component="img"
            src="/gotobed_logo.jpg"
            alt="GoToBed"
            sx={{
              borderRadius: 2.5,
              display: { xs: 'block', md: 'none' },
              height: 72,
              mb: 2,
              objectFit: 'cover',
              width: 72
            }}
          />
          <Typography
            variant="overline"
            sx={{ color: 'rgba(255,255,255,.72)', letterSpacing: 1.4 }}
          >
            GOTOBED ADMIN
          </Typography>
          <Typography variant="h4" sx={{ maxWidth: 580, mt: 0.5 }}>
            Каталогът ви, по-лесен за управление.
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,.76)', maxWidth: 620, mt: 1.5 }}>
            Намерете правилния продукт, направете промените и публикувайте уверено.
          </Typography>
          <Button
            component={Link}
            to="/products"
            endIcon={<ArrowForwardRoundedIcon />}
            sx={{
              bgcolor: 'white',
              color: 'primary.dark',
              mt: 3,
              '&:hover': { bgcolor: '#f8fafc' }
            }}
          >
            Към продуктите
          </Button>
        </Box>
      </Box>

    </VendorDashboardLayout>
  );
}
